export class EventStorageClosedHandler {
    // eslint-disable-next-line class-methods-use-this
    public handle(): void {
        const chatIcon = $('#minimized_chat');
        // @ts-ignore
        if (window.messageCount > 0) {
            chatIcon.css('display', 'block');
        }
    }
}
